/** Derive enamel stat tiles from recent hunts + photos (profile API has no lifetime totals yet). */

function deerSeenForHunt(hunt) {
  if (Number.isFinite(Number(hunt?.deer_seen))) return Number(hunt.deer_seen);
  return (Number(hunt?.does_seen) || 0) + (Number(hunt?.bucks_seen) || 0) + (Number(hunt?.fawns_seen) || 0);
}

export function deriveBuddyProfileStats(recentHunts = [], photos = []) {
  const sits = Array.isArray(recentHunts) ? recentHunts.length : 0;
  const deerSeen = (recentHunts || []).reduce((sum, h) => sum + deerSeenForHunt(h), 0);
  const harvestsFromHunts = (recentHunts || []).filter((h) => h?.harvest).length;
  const taken = Math.max(photos?.length || 0, harvestsFromHunts);
  const withDeer = (recentHunts || []).filter((h) => deerSeenForHunt(h) > 0).length;
  const seenRate = sits > 0 ? Math.round((withDeer / sits) * 100) : 0;
  return [
    { label: 'SITS', value: sits },
    { label: 'DEER SEEN', value: deerSeen },
    { label: 'TAKEN', value: taken },
    { label: 'SEEN RATE', value: `${seenRate}%` },
  ];
}

export function deerSeenCount(hunt) {
  return deerSeenForHunt(hunt);
}
